import { UtilService } from "./../services/util.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from "ngx-toastr";
import { Injectable } from "@angular/core";
import { URL } from "../../environments/environment";

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/finally";
import "rxjs/add/observable/throw";
import { ApiService } from "../services/api.service";
import { TokenResponse } from "../model/Response/TokenResponse";

interface toastConfig {
  progressAnimation: any;
  progressBar: boolean;
  onActivateTick: boolean;
  closeButton: boolean;
  positionClass: string;
}

@Injectable()
export class ApiInterceptorProvider implements HttpInterceptor {
  private toastConfig: toastConfig = {
    progressAnimation: "decreasing",
    progressBar: true,
    onActivateTick: true,
    closeButton: true,
    positionClass: "toast-bottom-center",
  };

  constructor(
    private ngxService: NgxUiLoaderService,
    private toastr: ToastrService,
    private util: UtilService,
    private api: ApiService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.ngxService.start();
    setTimeout(() => this.ngxService.stop(), 5000);
    let token = localStorage.getItem("admin_token");

    // Check if the request URL matches the one you want to exclude
    if (req.url.includes("https://maps.googleapis.com/maps/api/geocode/json")) {
      // Simply forward the request without modifying it
      return next.handle(req);
    }

    const isApiUrl = req.url.startsWith(URL.Jhacasso_API_URL);
    if (isApiUrl) {
      token = this.api.GetToken();
    }
    const authReq = req.clone({
      headers: req.headers.set("Authorization", "Bearer " + token),
    });
    return next
      .handle(authReq)
      .map((response: HttpEvent<any>) => {
        return response;
      })
      .catch((err: any) => {
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case 401:
              // Unauthorized: Try to refresh token if this is an API call.
              if (isApiUrl) {
                this.api.GenerateRefreshToken().subscribe(
                  (res: TokenResponse) => {
                    this.api.SaveTokens(res);
                  },
                  (err: any) => {
                    this.api.onLogOut();
                  }
                );
              }
              break;
            case 400:
              // Bad Request: Show error message and log out.
              this.toastr.error(err.error.msg, "Error!", this.toastConfig);
              this.api.onLogOut();
              this.util.navCtrl.navigateForward("/signin");
              break;
            case 422:
              // Unprocessable Entity: Display validation errors.
              for (const key in err.error.errors) {
                if (err.error.errors.hasOwnProperty(key)) {
                  this.toastr.error(err.error.errors[key], "Validation Error", this.toastConfig);
                  break; // show one error at a time
                }
              }
              break;
            case 404:
              // Not Found: Inform the user that the resource doesn't exist.
              this.toastr.error("Requested resource not found", "404 Not Found", this.toastConfig);
              break;
            case 500:
              // Internal Server Error: Notify the user and suggest trying again later.
              this.toastr.error("Server error, please try again later", "500 Internal Server Error", this.toastConfig);
              break;
            default:
              // Any other errors.
              this.toastr.error("An unexpected error occurred", `Error ${err.status}`, this.toastConfig);
              break;
          }
          return Observable.throw(err);
        }
      })
      .finally(() => {
        this.ngxService.stop();
      });
  }
}
